<template>
  <div>
    <label :class="style['search-container']">
      <input
        v-model="searchInput"
        type="text"
        :placeholder="$t('search')"
        :class="style['search-input']"
      />
      <span :class="style['cancel-icon']" @click="resetInput" />
    </label>

    <div v-if="loading" class="text-center mt-4">
      <t-spinner v-theme-font></t-spinner>
    </div>
    <image-list
      v-else
      wrap-class="img-group-full-page"
      :display-list="hotels"
      @click="clickOptions"
    />
  </div>
</template>

<script>
import ImageList from 'UtilityComponents/ImageList.vue'
import style from './scss/_pages.scss'
import { mapState } from 'pinia'
import { useDetailsPageStore } from 'Store/details-page'
import { useChatStore } from 'Store/chat'
import { useSettingsStore } from 'Store/settings'
import { Hotel } from 'src/apis'
import _debounce from 'lodash/debounce'

export default {
  components: {
    ImageList
  },

  setup() {
    return {
      detailsPageStore: useDetailsPageStore(),
      chatStore: useChatStore()
    }
  },

  data() {
    return {
      searchInput: '',
      search: '',
      page: 1,
      hotels: [],
      loading: true
    }
  },
  computed: {
    ...mapState(useSettingsStore, {
      hotelID: 'getHotelId'
    }),
    chat() {
      return this.detailsPageStore.chat
    },
    style: () => style,
    params() {
      let params = { page: this.page, search: this.search }
      const richMessage = this.chat?.message_rich
      if (richMessage) {
        params.status = richMessage.hotel_select_action
        if (richMessage.hotel_select_action_param_name)
          params[richMessage.hotel_select_action_param_name] =
            richMessage.hotel_select_action_param_value
      }

      return params
    }
  },
  watch: {
    searchInput: {
      immediate: true,
      handler() {
        this.updateSearch()
      }
    },
    params: {
      deep: true,
      immediate: true,
      handler(val) {
        this.fetchHotels(val)
      }
    }
  },
  methods: {
    clickOptions(hotel) {
      const messageRich = this.chat.message_rich
      const options = {
        action: messageRich.hotel_select_action,
        paramName: messageRich.hotel_select_action_param_name,
        paramValue: messageRich.hotel_select_action_param_value
      }
      this.chatStore.changeChat(hotel.code, options)
      this.detailsPageStore.closeDetailsPageShown()
    },
    resetInput() {
      this.searchInput = ''
    },
    async fetchHotels(params) {
      this.loading = true
      const res = await Hotel.getBranches(this.hotelID, params).catch(() => {})
      if (res) {
        this.hotels = res.data
      }
      this.loading = false
    },
    updateSearch: _debounce(function () {
      this.search = this.searchInput
    }, 300)
  }
}
</script>
